<ng-container *ngIf="initialDataState$ | async as initialDataState">
  <ng-container *ngIf="confirmOrderState$ | async as confirmOrderState">
    <ng-container *ngIf="calculateOrderState$ | async as calculateOrderState">
      <div class="logo">
        <img src="assets/images/logo/yunker-logo.svg" />
      </div>
      <form
        [formGroup]="orderForm"
        class="beton-form"
        [class.submitted]="confirmOrderState.success"
        [class.has-error]="confirmOrderState.error || calculateOrderState.error"
      >
        <ng-container *ngIf="!confirmOrderState.success; else successTpl">
          <h3 class="beton-form__title">Расчет стоимости</h3>

          <sd-select theme="concrete" class="beton-form__type-select">
            <ng-select
              *ngIf="!initialDataState.loading && initialDataState.success; else selectSkeletonTpl"
              formControlName="betonTypeCode"
              bindLabel="name"
              bindValue="code"
              [searchable]="false"
              [clearable]="false"
              [items]="initialDataState.value.types"
            ></ng-select>
          </sd-select>

          <sd-item-counter
            *ngIf="!initialDataState.loading && initialDataState.success; else inputSkeletonTpl"
            [min]="betonPriceData.minValue"
            [step]="betonPriceData.multiplicity"
            [unitName]="betonPriceData.unit.name"
            [showSaleUnit]="true"
            formControlName="volumeCbm"
            [selectedPrice]="betonPriceData"
            size="l"
            theme="concrete"
            [useDecimals]="true"
          ></sd-item-counter>

          <div>
            <sd-select theme="concrete" class="beton-form__address-select">
              <ng-select
                #deliveryAddressRef
                *ngIf="!initialDataState.loading && initialDataState.success; else selectSkeletonTpl"
                [items]="addressSuggestionsItems$ | async"
                [loading]="addressSuggestionsLoading$ | async"
                [typeahead]="addressSuggestionsQuery$"
                bindLabel="label"
                bindValue="value"
                placeholder="Адрес доставки"
                loadingText="Идет поиск..."
                notFoundText="Ничего не найдено"
                typeToSearchText="Начинайте вводить адрес"
                [dropdownPosition]="'bottom'"
                [editableSearchTerm]="true"
                formControlName="deliveryAddress"
                [clearable]="true"
                class="ng-select-searchable"
                (open)="onDeliveryAddressOpen()"
              ></ng-select>
            </sd-select>
            <ng-container *ngIf="orderForm.get('deliveryAddress') as control">
              <div *ngIf="control.invalid && control.touched" class="errors">
                <div *ngIf="control.hasError('incompleteAddress')">Неточный адрес доставки</div>
              </div>
              <div *ngIf="calculateOrderState.error" class="errors">
                <ng-container *ngIf="calculateOrderErrors$ | async as calculateOrderErrors; else unknownErrorTpl">
                  <div *ngFor="let msg of calculateOrderErrors">{{ msg }}</div>
                </ng-container>
                <ng-template #unknownErrorTpl><div>возникла ошибка, обновите страницу</div></ng-template>
              </div>
            </ng-container>
          </div>

          <div>
            <sd-checkbox
              theme="concrete"
              *ngIf="!initialDataState.loading && initialDataState.success; else checkboxSkeletonTpl"
              formControlName="needBetonPump"
            >
              с бетононасосом
            </sd-checkbox>
          </div>

          <div
            *ngIf="
              !initialDataState.loading && initialDataState.success && !calculateOrderState.loading;
              else priceSkeletonTpl
            "
            class="beton-form__total-block"
          >
            <span *ngIf="calculateOrderState.success; else defaultPrice">
              итого {{ calculateOrderState.value.totalPrice.toLocaleString().replace(',', ' ') }} &#8381;
            </span>
            <ng-template #defaultPrice><span>итого 0 &#8381;</span></ng-template>
          </div>

          <div>
            <ng-container *ngIf="orderForm.get('phone') as control">
              <sd-input theme="concrete" class="phone">
                <input
                  *ngIf="!initialDataState.loading && initialDataState.success; else inputSkeletonTpl"
                  mask="(000) 000 00 00"
                  type="tel"
                  prefix="+7 "
                  formControlName="phone"
                  sdPhoneMaskFix
                  sdPhoneAuthorizedUser
                />
              </sd-input>
            </ng-container>
          </div>

          <div>
            <button
              class="beton-form__submit-btn"
              sdButton
              [loading]="confirmOrderState.loading"
              [disabled]="orderForm.disabled"
              type="accent"
              radius="s"
              [fullWidth]="true"
              (click)="submitForm()"
            >
              Заказать
            </button>
          </div>

          <div class="beton-form__agreement">
            <sd-checkbox formControlName="agreement" theme="concrete">
              <sd-personal-data-agree-text></sd-personal-data-agree-text>
            </sd-checkbox>
          </div>

          <div *ngIf="confirmOrderState.error" class="errors centered">
            <ng-container *ngIf="confirmOrderErrors$ | async as confirmOrderErrors; else unknownErrorTpl">
              <div *ngFor="let msg of confirmOrderErrors">{{ msg }}</div>
            </ng-container>
            <ng-template #unknownErrorTpl><div>возникла ошибка, обновите страницу</div></ng-template>
          </div>
        </ng-container>
      </form>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #selectSkeletonTpl>
  <div class="skeleton skeleton__select"></div>
</ng-template>

<ng-template #inputSkeletonTpl>
  <div class="skeleton skeleton__input"></div>
</ng-template>

<ng-template #checkboxSkeletonTpl>
  <div class="skeleton skeleton__checkbox"></div>
</ng-template>

<ng-template #priceSkeletonTpl>
  <div class="skeleton skeleton__price"></div>
</ng-template>

<ng-template #successTpl>
  <div class="beton-form__success-msg">
    <h3 class="beton-form__title">Заявка отправлена</h3>

    <div class="message">
      мы позвоним вам в течение
      <br />
      10 минут, если не уложимся -
      <br />
      <b>вам скидка 10%</b>
    </div>
  </div>
</ng-template>
